"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.2.4'] && _();
}
catch (e) { }
